import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { ToneCardComponent } from '../../home/featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { NameTuneCardCSSStyleImpl } from './nametunecardcss';
import { NameTuneCardViewImpl } from './nametunecardview';

export class NameTuneCardComponent extends ToneCardComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new NameTuneCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
    
        return new NameTuneCardCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunecard/nametunecardcomponent.tsx